<template>
  <v-row no-gutters>
    <v-col>
      <div v-if="expanded">
        <v-text-field
          outlined
          dense
          hide-details
          :disabled="!hasPermission"
          single-line
          v-model="inputValue"
          class="pa-2"
          :label="item.input.placeholder"
          :append-icon="item.input.icon"
          @click:append="$emit('input-menu-activated', inputValue)"
          @keydown.enter="$emit('input-menu-activated', inputValue)"
        ></v-text-field>
      </div>
      <div v-else>
        <v-icon class="ml-4 mb-3">{{ item.input.icon }}</v-icon>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AnchorRouterInputMenu',
  props: {
    expanded: Boolean,
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    inputValue: null,
  }),
  computed: {
    user: vm => vm.$store.getters.user,
  },
  methods: {
    hasPermission(item) {
      return item.permission ? this.user.permissions.includes(item.permission) : true;
    },
  },
};
</script>
